(function(){
  'use strict';

  function moneyFormat(centsValue, format){
    format = format || '${{amount}}';
    var numeric = Number(centsValue || 0);
    if(!Number.isFinite(numeric)) numeric = 0;
    numeric = Math.max(0, Math.round(numeric));
    var value = (numeric / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(numeric / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  }

  function intValue(value, fallback){
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function cleanPercent(value, fallback){
    var parsed = intValue(value, fallback);
    return Math.max(0, Math.min(95, parsed));
  }

  function lineOriginal(item){
    return Math.max(0, Number(item && (
      item.original_line_price != null ? item.original_line_price :
      item.final_line_price != null ? item.final_line_price :
      item.line_price != null ? item.line_price : 0
    )) || 0);
  }

  function originalUnit(item){
    var qty = Math.max(1, Number(item && item.quantity || 1));
    var unit = Number(item && (
      item.original_price != null ? item.original_price :
      item.final_price != null ? item.final_price : 0
    ));
    if(!Number.isFinite(unit) || unit <= 0){
      unit = lineOriginal(item) / qty;
    }
    return Math.max(0, Math.floor(unit));
  }

  function shopifyStyleLineSavings(item, percent){
    percent = Math.max(0, Number(percent || 0));
    if(percent <= 0) return 0;
    var qty = Math.max(1, Number(item && item.quantity || 1));
    var unitSavings = Math.floor(originalUnit(item) * percent / 100);
    return Math.max(0, unitSavings * qty);
  }

  function productKey(item){
    return String((item && (item.product_id || item.variant_id || item.key)) || '');
  }

  function getGroupPercent(qty, p2, p3){
    qty = Number(qty || 0);
    if(qty >= 3) return p3;
    if(qty >= 2) return p2;
    return 0;
  }

  function offerLabel(tier, percent){
    percent = Number(percent || 0);
    if(tier >= 3) return 'Buy 3+ save ' + percent + '%';
    if(tier >= 2) return 'Buy 2 save ' + percent + '%';
    return 'Buy more, save instantly';
  }

  function calculateBundle(cart, p2, p3){
    var items = (cart && cart.items) || [];
    var subtotal = items.reduce(function(sum, item){ return sum + lineOriginal(item); }, 0);
    if(!subtotal){
      subtotal = Math.max(0, Number(cart && (cart.items_subtotal_price || cart.original_total_price || cart.total_price) || 0));
    }

    var groups = {};
    items.forEach(function(item){
      var key = productKey(item);
      if(!groups[key]) groups[key] = { qty: 0, lines: [] };
      groups[key].qty += Number(item.quantity || 0);
      groups[key].lines.push(item);
    });

    var lineMap = {};
    var totalSavings = 0;
    var strongestTier = 0;

    Object.keys(groups).forEach(function(key){
      var group = groups[key];
      var percent = getGroupPercent(group.qty, p2, p3);
      var tier = group.qty >= 3 ? 3 : (group.qty >= 2 ? 2 : 0);
      if(percent > 0) strongestTier = Math.max(strongestTier, tier);

      group.lines.forEach(function(item){
        var original = lineOriginal(item);
        var savings = percent > 0 ? shopifyStyleLineSavings(item, percent) : 0;
        savings = Math.max(0, Math.min(original, savings));
        var finalPrice = Math.max(0, original - savings);
        lineMap[item.key] = {
          key: item.key,
          productId: item.product_id,
          variantId: item.variant_id,
          groupQty: group.qty,
          lineQty: Number(item.quantity || 0),
          percent: percent,
          tier: tier,
          original: original,
          savings: savings,
          finalPrice: finalPrice
        };
        totalSavings += savings;
      });
    });

    totalSavings = Math.max(0, Math.min(subtotal, Math.round(totalSavings)));
    return {
      subtotal: subtotal,
      savings: totalSavings,
      total: Math.max(0, subtotal - totalSavings),
      active: totalSavings > 0,
      tier: strongestTier,
      percent: strongestTier >= 3 ? p3 : (strongestTier >= 2 ? p2 : 0),
      lineMap: lineMap
    };
  }

  function setLoading(form, state){
    if(!form) return;
    form.classList.toggle('is-cart-updating', !!state);
    var overlay = form.querySelector('[data-cart-loading]');
    if(overlay) overlay.hidden = !state;
  }

  function markCheckoutReturnLoading(){
    try{ sessionStorage.setItem('valse_cart_return_loading', '1'); }catch(e){}
  }

  function shouldShowReturnLoading(){
    try{ return sessionStorage.getItem('valse_cart_return_loading') === '1'; }catch(e){ return false; }
  }

  function clearCheckoutReturnLoading(){
    try{ sessionStorage.removeItem('valse_cart_return_loading'); }catch(e){}
  }

  function findLineInfo(row, lineMap){
    if(!row || !lineMap) return null;
    var key = row.getAttribute('data-cart-item') || row.dataset.key;
    if(key && lineMap[key]) return lineMap[key];
    return null;
  }

  function renderLinePrice(row, info, format){
    var priceEl = row && row.querySelector('[data-line-price]');
    if(!priceEl || !info) return;

    priceEl.setAttribute('data-line-original', String(info.original));
    priceEl.setAttribute('data-line-regular', String(info.original));
    priceEl.setAttribute('data-line-bundle-final', String(info.finalPrice));
    priceEl.setAttribute('data-line-bundle-savings', String(info.savings));

    if(info.percent > 0 && info.savings > 0){
      priceEl.classList.add('is-bundle-discounted');
      priceEl.innerHTML = '<s class="valse-line-compare">' + moneyFormat(info.original, format) + '</s>' +
        '<span class="valse-line-bundle-final">' + moneyFormat(info.finalPrice, format) + '</span>' +
        '<small class="valse-line-bundle-save">You save ' + moneyFormat(info.savings, format) + '</small>';
    }else{
      priceEl.classList.remove('is-bundle-discounted');
      priceEl.innerHTML = '<span>' + moneyFormat(info.original, format) + '</span>';
    }
  }

  function renderBadge(row, info, format){
    var badge = row && row.querySelector('[data-bundle-badge]');
    if(!badge || !info) return;

    row.classList.toggle('valse-has-quantity-savings', info.percent > 0 && info.savings > 0);
    if(info.percent > 0 && info.savings > 0){
      badge.hidden = false;
      badge.textContent = offerLabel(info.tier, info.percent) + ' · You save ' + moneyFormat(info.savings, format);
      badge.classList.toggle('is-bundle-20', info.tier >= 3);
    }else{
      badge.hidden = true;
      badge.textContent = '';
      badge.classList.remove('is-bundle-20');
    }
  }

  function updateRows(form, cart, calc){
    if(!form || !cart) return;
    var format = form.dataset.moneyFormat || '${{amount}}';
    form.querySelectorAll('[data-cart-item]').forEach(function(row){
      var info = findLineInfo(row, calc.lineMap);
      if(info){
        renderLinePrice(row, info, format);
        renderBadge(row, info, format);
      }else{
        var priceEl = row.querySelector('[data-line-price]');
        var original = Number(priceEl && (priceEl.getAttribute('data-line-regular') || priceEl.getAttribute('data-line-original')) || 0);
        var fallback = { original: original, savings: 0, finalPrice: original, percent: 0, tier: 0 };
        renderLinePrice(row, fallback, format);
        renderBadge(row, fallback, format);
      }
    });
  }

  function updateTotals(form, calc){
    if(!form || !calc) return;
    var format = form.dataset.moneyFormat || '${{amount}}';

    form.dataset.cartOriginalSubtotal = String(calc.subtotal);
    form.dataset.cartSubtotalCents = String(calc.subtotal);
    form.dataset.cartTotal = String(calc.total);
    form.dataset.bundleSavingsCents = String(calc.savings);
    form.dataset.bundleActive = calc.active ? 'true' : 'false';
    form.dataset.bundleTier = String(calc.tier || 0);

    var subtotalEl = form.querySelector('[data-cart-subtotal]');
    var totalEl = form.querySelector('[data-cart-estimated-total]');
    var totalRow = form.querySelector('[data-estimated-total-row]');
    var totalLabel = form.querySelector('[data-estimated-total-label]');
    var discountRow = form.querySelector('[data-bundle-discount-row]');
    var discountAmount = form.querySelector('[data-bundle-discount-amount]');
    var discountLabel = form.querySelector('[data-bundle-discount-label]');
    var savingsRow = form.querySelector('[data-total-savings-row]');
    var savingsAmount = form.querySelector('[data-total-savings-amount]');
    var note = form.querySelector('[data-savings-note]');
    var noteTitle = form.querySelector('[data-savings-title]');
    var noteText = form.querySelector('[data-savings-note-text]');

    if(subtotalEl) subtotalEl.textContent = moneyFormat(calc.subtotal, format);
    if(totalEl) totalEl.textContent = moneyFormat(calc.total, format);

    if(discountRow) discountRow.hidden = !calc.active;
    if(savingsRow) savingsRow.hidden = !calc.active;
    if(discountAmount) discountAmount.textContent = '-' + moneyFormat(calc.savings, format);
    if(discountLabel) discountLabel.textContent = calc.active ? offerLabel(calc.tier, calc.percent) : 'Instant savings';
    if(savingsAmount) savingsAmount.textContent = moneyFormat(calc.savings, format);

    if(totalRow) totalRow.classList.toggle('is-discounted', calc.active);
    if(totalLabel) totalLabel.textContent = 'Estimated total';
    if(note) note.classList.toggle('is-bundle-active', calc.active);
    if(noteTitle) noteTitle.textContent = calc.active ? (offerLabel(calc.tier, calc.percent) + ' applied') : 'Instant savings';
    if(noteText){
      noteText.textContent = calc.active
        ? 'Same-item savings are active in your cart.'
        : 'Same item only: Buy 2 save ' + cleanPercent(form.dataset.bundlePercent2, 15) + '%, Buy 3+ save ' + cleanPercent(form.dataset.bundlePercent3, 20) + '%.';
    }
  }

  function removeOldDiscountUI(form){
    if(!form) return;
    form.querySelectorAll('.valse-discount,[data-discount-row],[data-discount-message],[data-discount-input],[data-discount-apply],[data-discount-remove]').forEach(function(el){
      var wrap = el.closest && el.closest('.valse-discount');
      if(wrap) wrap.style.display = 'none';
      else el.style.display = 'none';
    });
  }

  function refreshWithCart(form, cart){
    if(!form) return;
    var p2 = cleanPercent(form.dataset.bundlePercent2, 15);
    var p3 = cleanPercent(form.dataset.bundlePercent3, 20);
    var calc = calculateBundle(cart || {items:[]}, p2, p3);
    updateRows(form, cart || {items:[]}, calc);
    updateTotals(form, calc);
    removeOldDiscountUI(form);
    clearCheckoutReturnLoading();
    setTimeout(function(){ setLoading(form, false); }, 160);
  }

  function refresh(form){
    if(!form) return;
    removeOldDiscountUI(form);
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ refreshWithCart(form, cart); })
      .catch(function(){ clearCheckoutReturnLoading(); setLoading(form, false); });
  }

  function setupInitialRows(form){
    if(!form) return;
    form.querySelectorAll('[data-cart-item]').forEach(function(row){
      var badge = row.querySelector('[data-bundle-badge]');
      if(badge && row.querySelector('[data-cart-qty]') && Number(row.querySelector('[data-cart-qty]').value || 1) < 2){
        badge.hidden = true;
      }
    });
  }

  var refreshTimer = null;

  function refreshAll(reason){
    clearTimeout(refreshTimer);
    var showReturnLoading = shouldShowReturnLoading();
    document.querySelectorAll('[data-cart-form]').forEach(function(form){
      if(showReturnLoading) setLoading(form, true);
    });
    refreshTimer = setTimeout(function(){
      document.querySelectorAll('[data-cart-form]').forEach(function(form){
        setupInitialRows(form);
        if(showReturnLoading) setLoading(form, true);
        refresh(form);
      });
    }, showReturnLoading ? 40 : (reason === 'pageshow' ? 60 : 0));
  }

  document.addEventListener('DOMContentLoaded', function(){ refreshAll('dom'); });
  window.addEventListener('pageshow', function(){ refreshAll('pageshow'); });
  window.addEventListener('focus', function(){ refreshAll('focus'); });
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) refreshAll('visible'); });
  document.addEventListener('shopify:section:load', function(){ refreshAll('section'); });

  document.addEventListener('valse:cart-updating', function(e){
    var form = e.detail && e.detail.form;
    if(form) setLoading(form, true);
  });

  document.addEventListener('valse:cart-updated', function(e){
    document.querySelectorAll('[data-cart-form]').forEach(function(form){
      refreshWithCart(form, (e.detail && e.detail.cart) || { items: [], item_count: 0 });
    });
  });

  document.addEventListener('click', function(e){
    var checkout = e.target.closest('[data-cart-checkout]');
    if(!checkout) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var form = checkout.closest('[data-cart-form]');
    var tier = Number(form && form.dataset.bundleTier || 0);
    var code = tier >= 3 ? (form && form.dataset.bundleCode3) : (tier >= 2 ? (form && form.dataset.bundleCode2) : '');

    markCheckoutReturnLoading();

    if(code){
      sessionStorage.setItem('valse_active_bundle_savings', code);
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.Shopify.routes.root+'checkout');
    }else{
      window.location.href = window.Shopify.routes.root + 'checkout';
    }
  }, true);
})();
